import { instagram, linkedin, Logo } from 'src/assets/images';
import { facebook } from 'src/assets/images';
import { twitter } from 'src/assets/images';
import { Link } from "react-router-dom";


const Footer = () => {
    return (
        <footer className="footer-background text-white">
            <div className="container">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[auto,auto,1fr,1fr] gap-20 final-contain-contain">

                    {/* Logo Section */}
                    <div className="space-y-2">
                        <img src={Logo} alt="Logo" className="w-32" />
                    </div>

                    {/* Contact Us Section */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold fatix-contact-header">Contact Us</h3>
                        <p className="fatix-contact-subheader">Email: fatix.faham@yahoo.com</p>
                        <p className="fatix-contact-subheader">Head Office: 22 Banjoko Street, Oshodi, Lagos</p>
                        <p className="fatix-contact-subheader">Branch Office: 433 Agege Motor Road, Bolade, Oshodi, Lagos</p>
                        <p className="fatix-contact-subheader">Ibadan Branch: Last Gate, Old Generator House, New Gbagi Market, Ibadan State.</p>
                        <p className="fatix-contact-subheader">Phone: +234 903 6410 169</p>
                    </div>

                    {/* Quick Links Section */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold fatix-contact-header">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><a href="/shop" className="hover:underline fatix-contact-subheader">New Arrivals</a></li>
                            <li><a href="/shop" className="hover:underline fatix-contact-subheader">Popular Collections</a></li>
                            <li><a href="/shop" className="hover:underline fatix-contact-subheader">All Fatix Collections</a></li>
                            <li><a href="/contact" className="hover:underline fatix-contact-subheader">Wholesales</a></li>
                        </ul>
                    </div>

                    {/* Discount Section */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold fatix-contact-header">Social Media</h3>
                        {/* <input
                            type="text"
                            placeholder="Name"
                            className="w-full p-2 text-gray-900 rounded-md newsletter-text-border"
                        />
                        <input
                            type="email"
                            placeholder="Email Address"
                            className="w-full p-2 text-gray-900 rounded-md newsletter-text-border"
                        />
                        <button className="w-full text-white py-2 rounded-md subscribe-to-newsletter">
                            Subscribe to our newsletter
                        </button> */}
                        <div className="social-icon-container-flex ">
                            <div className="social-icon-container">
                                <Link to={"https://www.facebook.com/profile.php?id=61578678272719"} target="_blank"><img src={facebook} alt="Facebook" /></Link>
                                <Link to={"https://x.com/faham_fatix"} target="_blank"><img src={twitter} alt="Twitter" /></Link>
                                <Link to={"https://www.instagram.com/fatix_wax"} target="_blank"><img src={instagram} alt="Instagram" /></Link>
                                {/* <img src={linkedin} alt="LinkedIn" /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='bg-background-footer-fatix'>
                <div className='container footer-flex-data-ule'>
                    {/* <div className="">
                        <a href='/'> <img src={Logo} alt='' /></a>
                    </div> */}
                    <div className="fatix-copyeight-text">
                        <p>© 2025 Fatix Wax. All rights reserved</p>
                    </div>
                    {/* <div className="social-icon-container-flex ">
                        <div className="social-icon-container">
                            <img src={facebook} alt="Facebook" />
                            <img src={twitter} alt="Twitter" />
                            <img src={instagram} alt="Instagram" />
                            <img src={linkedin} alt="LinkedIn" />
                        </div>
                    </div> */}
                </div>
            </div>
        </footer>

    );
};

export default Footer;

